<!-- Desktop (lg+) -->
<div class="d-none d-lg-block">
    <div class="table-responsive">
        <table class="table table-striped table-hover align-middle">
            <thead>
                <tr>
                    @for (col of columns(); track col.id;) {
                    <th scope="col" [class]="alignClass(col.align)" [class.text-nowrap]="col.nowrap"
                        [width]="col.width ? col.width+'%' : 'auto'">
                        {{ col.header }}
                    </th>
                    }
                    @if (showActions()) {
                    <th scope="col" class="text-center text-nowrap" [width]="'10%'">Actions</th>
                    }
                </tr>
            </thead>

            <tbody>
                @for (item of items(); track trackBy()($index, item)) {
                <tr>
                    @for (col of columns(); track col.id) {
                    <td [class]="alignClass(col.align)" [class.text-nowrap]="col.nowrap">
                        @if (col.cellTemplate) {
                        <ng-container [ngTemplateOutlet]="col.cellTemplate"
                            [ngTemplateOutletContext]="{ $implicit: item }" />
                        }@else if (col.isImage) {
                        @let imageUrl = col.value?.(item);
                        @if (imageUrl){
                        <img class="filled-avatar" [src]="imageUrl" height="32" [class.rounded]="col.rounded" />
                        }@else {
                        <div class="empty-avatar"></div>
                        }
                        } @else {
                        {{ col.value?.(item) }}
                        }
                    </td>
                    }

                    @if (showActions()) {
                    <td class="text-end text-nowrap">
                        <div class="btn-group">
                            @for (a of inlineActionsFor(item); track a.id) {
                            <button type="button" class="btn btn-light" [disabled]="isDisabled(a, item)"
                                (click)="onAction(a.id, item)" [ngClass]="{ 'text-danger': a.danger }">
                                @if (a.icon) { <i [class]="a.icon" aria-hidden="true"></i> }
                                <span class="ms-2">{{ a.label }}</span>
                            </button>
                            }

                            @if (hasDropdown(item)) {
                            <div ngbDropdown class="btn-group" placement="bottom-end">
                                <button type="button" class="btn btn-light" ngbDropdownToggle aria-label="More actions">
                                    <i class="fa-solid fa-ellipsis-vertical" aria-hidden="true"></i>
                                </button>

                                <div ngbDropdownMenu>
                                    @for (a of dropdownActionsFor(item); track a.id) {
                                    <button type="button" ngbDropdownItem [disabled]="isDisabled(a, item)"
                                        (click)="onAction(a.id, item)" [ngClass]="{ 'text-danger': a.danger }">
                                        @if (a.icon) { <i [class]="a.icon" aria-hidden="true"></i> }
                                        <span class="ms-2">{{ a.label }}</span>
                                    </button>
                                    }
                                </div>
                            </div>
                            }
                        </div>
                    </td>
                    }
                </tr>
                }
            </tbody>
        </table>
    </div>
</div>

<!-- Mobile (<lg): records -->
<div class="d-block d-lg-none record-list">
    @for (item of items(); track trackBy()($index, item)) {
    <article class="record" [class.record__even]="$index%2">
        <header class="record__header">
            <span class="record__title">
                @if (columns()[0]?.cellTemplate) {
                <ng-container [ngTemplateOutlet]="columns()[0]!.cellTemplate!"
                    [ngTemplateOutletContext]="{ $implicit: item }" />
                }@else if (columns()[0].isImage) {
                <img [src]="columns()[0].value?.(item)" height="32" />
                } @else {
                {{ columns()[0]?.value?.(item) }}
                }
            </span>

            @if (showActions()) {
            <div class="record__menu" ngbDropdown placement="bottom-end">
                <button type="button" class="btn btn-light btn-sm" ngbDropdownToggle aria-label="More actions">
                    <i class="fa-solid fa-ellipsis-vertical" aria-hidden="true"></i>
                </button>

                <div ngbDropdownMenu>
                    @for (a of visibleActionsFor(item); track a.id) {
                    <button type="button" ngbDropdownItem [disabled]="isDisabled(a, item)"
                        (click)="onAction(a.id, item)" [ngClass]="{ 'text-danger': a.danger }">
                        @if (a.icon) { <i [class]="a.icon" aria-hidden="true"></i> }
                        <span class="ms-2">{{ a.label }}</span>
                    </button>
                    }
                </div>
            </div>
            }
        </header>

        <dl class="record__grid">
            @for (col of columns().slice(1); track col.id) {
            @if (!col.hideOnMobile) {
            <div class="record__row">
                <dt class="record__label">{{ col.header }}</dt>
                <dd class="record__value">
                    @if (col.cellTemplate) {
                    <ng-container [ngTemplateOutlet]="col.cellTemplate"
                        [ngTemplateOutletContext]="{ $implicit: item }" />
                    } @else {
                    {{ col.value?.(item) }}
                    }
                </dd>
            </div>
            }
            }
        </dl>
    </article>
    }
</div>
@if (paginated() && totalItems() > pageSize()) {
<div class="d-flex justify-content-center mt-3">
    <ngb-pagination [collectionSize]="totalItems()" [page]="page()" [pageSize]="pageSize()" [maxSize]="5"
        [boundaryLinks]="true" [rotate]="true" (pageChange)="pageChange.emit($event)">
    </ngb-pagination>
</div>
}